'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCalendarYearsSinceInception = exports.getYearsSinceInception = exports.getCalendarYears = exports.calculateFromDateByDateOptionList = exports.addYearMapsToDateRangeArray = exports.getFullYear = exports.generateLocale = exports.getLocalFormattedDate = exports.getTranslatedDateYear = exports.getTranslatedDate = exports.getLocalFormattedDateForInjectIntl = exports.getEffectiveDateHeader = exports.getTranslatedHeaderWithDate = exports.getDateInMonthYearFormatNoOffset = exports.getDateInMonthYearWithFormat = exports.getDateInMonthYearFormatInMMYYYY = exports.getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick = exports.getTimeInHoursAndMinutes = exports.formattedDateValObj = exports.getIntlFormattedDate = exports.convertDateToLastDayOfMonth = exports.fromDateIsSameOrAfterToDate = exports.fromDateIsAfterToDate = exports.fromDateIsBeforeToDate = exports.dateRangeIsGreaterThanAYear = exports.validateDateMMYYYY = exports.formatDateForLocale = exports.isValidDate = exports.getBusinessDatesFromGivenDateArray = exports.getDateAfterNMonths = exports.getMonthEndDateBeforeNMonths = exports.getDateBeforeNMonths = exports.getMonthEndsBetweenDatesForBP1 = exports.getDateInMonthDayYearFormat = exports.getDateInMonthYearFormat = exports.getFutureDatesFromGivenDateForGivenTickInterval = exports.getDatesFromGivenDateForGivenTickInterval = exports.getDateInSpecificFormat = exports.getFirstDateForLastNMonths = exports.getTimeInHoursAndMinutesInTimeZoneFormat = exports.getDateInESTFormat = exports.getTimeInHoursInESTFormat = exports.getTimeInHoursAndMinutesInESTFormat = exports.convertTimeTo12HrFrom24HrFormat = exports.getDateInYYYYMMDDSlashFormat = exports.getDateInDDMMYYYSlashFormat = exports.getDateInSlashFormatOrNA = exports.getDateInDotFormat = exports.getDateInSlashFormat = exports.getFormattedDateAvailebleHeader = exports.MONTHS = exports.edpiDateFormat = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactIntl = require('react-intl');

var _ramda = require('ramda');

var _constants = require('./constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _string_utility = require('./string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('./functional_utility');

var _collection_utility = require('./collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var edpiDateFormat = exports.edpiDateFormat = 'YYYY-MM-DD';

var MONTHS = exports.MONTHS = [{ value: 'January', translationKey: 'month-January' }, { value: 'February', translationKey: 'month-February' }, { value: 'March', translationKey: 'month-March' }, { value: 'April', translationKey: 'month-April' }, { value: 'May', translationKey: 'month-May' }, { value: 'June', translationKey: 'month-June' }, { value: 'July', translationKey: 'month-July' }, { value: 'August', translationKey: 'month-August' }, { value: 'September', translationKey: 'month-September' }, { value: 'October', translationKey: 'month-October' }, { value: 'November', translationKey: 'month-November' }, { value: 'December', translationKey: 'month-December' }];

var DateFormatter = {
  getFormattedDateAvailebleHeader: function getFormattedDateAvailebleHeader(inputEffectiveDate) {
    return getIntlFormattedDate('pdp-date-available-from', '', inputEffectiveDate);
  },
  convertDateToStartDayOfMonth: function convertDateToStartDayOfMonth(fromDate) {
    var inputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/YYYY';

    return (0, _moment2.default)(fromDate, inputFormat).startOf('month').format('YYYY-MM-DD');
  },
  convertDateToLastDayOfMonth: function convertDateToLastDayOfMonth(fromDate) {
    var inputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/YYYY';

    return (0, _moment2.default)(fromDate, inputFormat).endOf('month').format('YYYY-MM-DD');
  },
  convertTimeTo12HrFrom24HrFormat: function convertTimeTo12HrFrom24HrFormat(timeIn24HrFormat) {
    if (!/^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(timeIn24HrFormat)) {
      return '-';
    }
    return (0, _moment2.default)(timeIn24HrFormat, 'HH:mm').format('hh:mm A');
  },
  dateRangeIsGreaterThanAYear: function dateRangeIsGreaterThanAYear(fromDate, toDate, inputDateFormat) {
    var fromDateObj = (0, _moment2.default)(fromDate, inputDateFormat);
    var toDateObj = (0, _moment2.default)(toDate, inputDateFormat);
    return toDateObj.diff(fromDateObj, 'years', true) >= 1;
  },
  formatDateForLocale: function formatDateForLocale(inputDate) {
    return isValidDate(inputDate) ? _react2.default.createElement(_reactIntl.FormattedDate, {
      value: new Date(inputDate),
      month: '2-digit',
      year: 'numeric',
      day: '2-digit',
      timeZone: 'UTC'
    }) : '';
  },
  formattedDateValObj: function formattedDateValObj(inputEffectiveDate) {
    var isUTC = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


    if ((0, _ramda.isNil)(inputEffectiveDate)) {
      return {};
    }

    var effectiveDate = new Date(inputEffectiveDate);
    var effectiveDay = void 0,
        effectiveMonth = void 0,
        effectiveYear = void 0;
    if (isUTC) {
      effectiveDay = effectiveDate.getUTCDate();
      effectiveMonth = effectiveDate.getUTCMonth();
      effectiveYear = effectiveDate.getUTCFullYear();
    } else {
      effectiveDay = effectiveDate.getDate();
      effectiveMonth = effectiveDate.getMonth();
      effectiveYear = effectiveDate.getFullYear();
    }

    return {
      date: ('0' + effectiveDay).slice(-2),
      month: ('0' + (effectiveMonth + 1)).slice(-2),
      monthInSingleDigit: effectiveMonth + 1,
      year: effectiveYear,
      monthInWord: isNaN(effectiveMonth) ? '' : _string_utility2.default.renderFormattedLabel(MONTHS[effectiveMonth].value, MONTHS[effectiveMonth].translationKey)
    };
  },
  fromDateIsBeforeToDate: function fromDateIsBeforeToDate(fromDate, toDate, inputDateFormat) {
    var fromDateObj = (0, _moment2.default)(fromDate, inputDateFormat);
    var toDateObj = (0, _moment2.default)(toDate, inputDateFormat);
    return fromDateObj.isBefore(toDateObj);
  },
  fromDateIsAfterToDate: function fromDateIsAfterToDate(fromDate, toDate, inputDateFormat) {
    var fromDateObj = (0, _moment2.default)(fromDate, inputDateFormat);
    var toDateObj = (0, _moment2.default)(toDate, inputDateFormat);
    return fromDateObj.isAfter(toDateObj);
  },
  fromDateIsSameOrAfterToDate: function fromDateIsSameOrAfterToDate(fromDate, toDate) {
    var fromDateObj = (0, _moment2.default)(fromDate);
    var toDateObj = (0, _moment2.default)(toDate);
    if (fromDateObj.isValid() && toDateObj.isValid()) {
      return fromDateObj.isSameOrAfter(toDateObj);
    } else {
      return '-';
    }
  },
  generateLocale: function generateLocale() {
    var currentConfiguration = window.fundsMarketingConfiguration;
    if (!(0, _ramda.isNil)(currentConfiguration) && !(0, _ramda.isNil)(currentConfiguration.language) && currentConfiguration.language === 'en') {
      _momentTimezone2.default.locale('en-US');
      return;
    }

    _momentTimezone2.default.locale(_string_utility2.default.generateLocale());
  },
  getBusinessDatesFromGivenDateArray: function getBusinessDatesFromGivenDateArray(n, tickInterval, dateArray) {
    var dates = [];
    var date = void 0;
    var dayOfWeek = 0;
    var endDate = dateArray[dateArray.length - 1];
    dates.push(endDate);
    var formattedDate = void 0;
    for (var i = 1; i < n - 1; i++) {
      date = (0, _moment2.default)(endDate).subtract(i * tickInterval, 'months');
      dayOfWeek = date.isoWeekday();
      if (dayOfWeek === 7) {
        date = date.subtract(2, 'days');
      } else if (dayOfWeek === 6) {
        date = date.subtract(1, 'days');
      }
      formattedDate = (0, _moment2.default)(date).format(edpiDateFormat);
      if (!_collection_utility.CollectionUtility.includes(dateArray, formattedDate)) {
        dayOfWeek = date.isoWeekday();
        if (dayOfWeek === 1) {
          date = date.add(1, 'days');
        } else {
          date = date.subtract(1, 'days');
        }
      }
      dates.push((0, _moment2.default)(date).format(edpiDateFormat));
    }
    dates.push(dateArray[0]);
    return dates;
  },
  getDateAfterNMonths: function getDateAfterNMonths(inputDate, numberMonths) {
    return (0, _moment2.default)(inputDate).add(numberMonths, 'M').format('YYYY-MM-DD');
  },
  getDateBeforeNMonths: function getDateBeforeNMonths(inputDate, numberMonths) {
    return (0, _moment2.default)(inputDate).subtract(numberMonths, 'M').format('YYYY-MM-DD');
  },
  getDateInYYYYMMDDSlashFormat: function getDateInYYYYMMDDSlashFormat(date) {
    if (!isValidDate(date)) {
      return null;
    }
    return (0, _moment2.default)(date).format('YYYY/MM/DD');
  },
  getDateInDDMMYYYSlashFormat: function getDateInDDMMYYYSlashFormat(date) {
    if (!isValidDate(date)) {
      return null;
    }
    return (0, _moment2.default)(date).format('DD/MM/YYYY');
  },
  getDateInDotFormat: function getDateInDotFormat(inputDate) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MM.DD.YY";

    if (!(0, _moment2.default)(inputDate, edpiDateFormat, true).isValid()) {
      return null;
    }
    return (0, _moment2.default)(inputDate).format(format);
  },
  getDateInESTFormat: function getDateInESTFormat(inputDateInStringFormat) {
    if ((0, _functional_utility.isNilOrEmpty)(inputDateInStringFormat)) {
      return null;
    }

    return (0, _momentTimezone2.default)(inputDateInStringFormat).tz('America/New_York').format('MM/DD/YYYY');
  },
  getDateInMonthYearFormat: function getDateInMonthYearFormat(inputDateInStringFormat) {
    generateLocale();
    return (0, _momentTimezone2.default)(inputDateInStringFormat).tz('America/New_York').format('MMM YY');
  },
  getDateInMonthYearFormatInMMYYYY: function getDateInMonthYearFormatInMMYYYY(inputDateInStringFormat) {
    return getDateInMonthYearWithFormat(inputDateInStringFormat, 'MM/YYYY');
  },
  getDateInSlashFormat: function getDateInSlashFormat(inputDate) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MM/DD/YYYY";

    if (!(0, _moment2.default)(inputDate, edpiDateFormat, true).isValid()) {
      return null;
    }
    return (0, _moment2.default)(inputDate).format(format);
  },
  getDateInSlashFormatOrNA: function getDateInSlashFormatOrNA(inputDate) {
    if (!(0, _moment2.default)(inputDate, edpiDateFormat, true).isValid()) {
      return '-';
    }

    return getIntlFormattedDate('date-format', '', inputDate);
  },
  getDateInSpecificFormat: function getDateInSpecificFormat(inputDate, dateFormat) {
    var inputDateFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _momentTimezone2.default.locale(generateLocale());
    return (0, _moment2.default)(inputDate, inputDateFormat).format(dateFormat);
  },
  getDatesFromGivenDateForGivenTickInterval: function getDatesFromGivenDateForGivenTickInterval(n, endDate, tickInterval) {
    var dates = [];
    var date = void 0;
    for (var i = 0; i < n; i++) {
      date = (0, _moment2.default)(endDate).subtract(i * tickInterval, 'months');
      dates.push((0, _moment2.default)(date).format(edpiDateFormat));
    }
    return dates;
  },
  getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick: function getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick(n, startDate, endDate, tickIntervals) {
    var dates = [];
    var maxTicks = tickIntervals - 2;

    var sixMonthsOrMoreRange = (0, _moment2.default)(endDate).diff(startDate, 'months', true) >= 6;
    var expandedEndDate = void 0,
        expandedStartDate = void 0;

    if (sixMonthsOrMoreRange) {
      expandedEndDate = (0, _moment2.default)(endDate).endOf('month');
      expandedStartDate = (0, _moment2.default)(startDate).startOf('days');
    } else {
      expandedEndDate = (0, _moment2.default)(endDate).add(0, 'days');
      expandedStartDate = (0, _moment2.default)(startDate).subtract(0, 'days');
    }
    var rangeInDays = (0, _moment2.default)(expandedEndDate).diff(expandedStartDate, 'days');
    var intervalInDays = Math.ceil(rangeInDays / (tickIntervals - 1));

    var rangeInMonths = (0, _moment2.default)(expandedEndDate).diff(expandedStartDate, 'months');
    var intervalInMonths = Math.ceil(rangeInMonths / (tickIntervals - 1));
    if ((0, _ramda.and)(sixMonthsOrMoreRange, rangeInMonths < 12)) {
      maxTicks = 1;
      if (n !== 3) {
        intervalInMonths = 2;
        maxTicks = 4;
      }
    }

    var date = void 0;
    dates.push((0, _moment2.default)(expandedEndDate).endOf('day').format(edpiDateFormat));
    for (var i = maxTicks; i > 0; i--) {
      if (sixMonthsOrMoreRange) {
        date = (0, _moment2.default)(expandedStartDate).add(i * intervalInMonths, 'months');
        if ((0, _moment2.default)(date).endOf('months').isBefore((0, _moment2.default)(expandedEndDate).startOf('months'))) {
          dates.push((0, _moment2.default)(date).endOf('day').format(edpiDateFormat));
        }
      } else {
        if (i === maxTicks) {
          if ((0, _moment2.default)(expandedEndDate).diff((0, _moment2.default)(expandedStartDate).add(i * intervalInDays, 'days'), 'days') > 2) {
            date = (0, _moment2.default)(expandedStartDate).add(i * intervalInDays, 'days');
          }
        } else {
          date = (0, _moment2.default)(expandedStartDate).add(i * intervalInDays, 'days');
        }
        if ((0, _moment2.default)(date).isBefore(expandedEndDate)) {
          dates.push((0, _moment2.default)(date).endOf('day').format(edpiDateFormat));
        }
      }
    }
    dates.push((0, _moment2.default)(expandedStartDate).endOf('day').format(edpiDateFormat));
    return dates;
  },
  getDateInMonthDayYearFormat: function getDateInMonthDayYearFormat(inputDate) {
    if ((0, _ramda.isNil)(inputDate)) {
      return '';
    }

    generateLocale();
    return (0, _momentTimezone2.default)(inputDate).tz('America/New_York').format('MMM DD YYYY');
  },
  getDateInMonthYearFormatNoOffset: function getDateInMonthYearFormatNoOffset(inputDateInStringFormat, dateFormat) {
    generateLocale();
    return getDateInMonthYearWithFormat(inputDateInStringFormat, dateFormat);
  },
  getDateInMonthYearWithFormat: function getDateInMonthYearWithFormat(inputDateInStringFormat, format) {
    return (0, _moment2.default)(inputDateInStringFormat).format(format);
  },
  getEffectiveDateHeader: function getEffectiveDateHeader(id, inputEffectiveDate, country, role, breakpoint) {
    var cssClass = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "margin-top--25 float-right text-right";
    var messageKey = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'label-for-as-of';

    if (breakpoint < 3) {
      cssClass = "margin-top--25 padding-left-16 display-inline";
    }
    var dateMarkup = void 0;

    if ((0, _ramda.isNil)(inputEffectiveDate)) {
      return null;
    }

    if ((0, _ramda.includes)(country, _constants2.default.getCustomAsOfDateCountriesList())) {
      dateMarkup = getTranslatedHeaderWithDate(inputEffectiveDate);
    } else {
      dateMarkup = _react2.default.createElement(
        'span',
        null,
        _string_utility2.default.renderFormattedLabel("As of ", messageKey, { role: role }),
        getLocalFormattedDate(inputEffectiveDate)
      );
    }

    return _react2.default.createElement(
      'span',
      { className: cssClass + ' disclaimer2' },
      _react2.default.createElement(
        'span',
        { id: id + '-effective-date' },
        dateMarkup
      )
    );
  },
  getFirstDateForLastNMonths: function getFirstDateForLastNMonths(n) {
    var dates = [];
    var firstDateOfCurrentMonth = (0, _moment2.default)().startOf("month").format(edpiDateFormat);
    var lastMonthDate = void 0;
    for (var i = 0; i < n; i++) {
      lastMonthDate = (0, _moment2.default)(firstDateOfCurrentMonth).subtract(i, 'months');
      dates.push((0, _moment2.default)(lastMonthDate).format(edpiDateFormat));
    }
    return dates;
  },
  getFutureDatesFromGivenDateForGivenTickInterval: function getFutureDatesFromGivenDateForGivenTickInterval(n, startDate, tickInterval) {
    var dates = [];
    var date = void 0;
    for (var i = 0; i < n; i++) {
      date = (0, _moment2.default)(startDate).add(i * tickInterval, 'months');
      dates.push((0, _moment2.default)(date).format(edpiDateFormat));
    }
    return dates;
  },
  getIntlFormattedDate: function getIntlFormattedDate(id, defaultMessage, inputEffectiveDate) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: id,
      defaultMessage: defaultMessage,
      values: formattedDateValObj(inputEffectiveDate) });
  },
  getLocalFormattedDate: function getLocalFormattedDate(effectiveDate) {
    return getIntlFormattedDate('date-format', '{month}/{date}/{year}', effectiveDate);
  },
  getLocalFormattedDateForInjectIntl: function getLocalFormattedDateForInjectIntl(inputDate, intl) {
    var isUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return _string_utility2.default.getLocalizedString(intl, '{month}/{date}/{year}', 'date-format', formattedDateValObj(inputDate, isUTC));
  },
  getMonthEndsBetweenDatesForBP1: function getMonthEndsBetweenDatesForBP1(startDate, endDate) {
    var date1 = (0, _moment2.default)(startDate);
    var date2 = (0, _moment2.default)(endDate);
    var nextDate = void 0;
    var runningEndDate = void 0;
    var dates = [];
    var diffMonths = date2.diff(date1, 'months');
    var ticks = 2;
    var monthInterval = Math.round(diffMonths / 3);
    dates.push(date1.format('YYYY-MM-DD'));
    nextDate = date1;
    for (var i = 0; i < ticks; i++) {
      nextDate = nextDate.add(monthInterval, 'M');
      runningEndDate = (0, _moment2.default)(nextDate).endOf('month');
      dates.push(runningEndDate.format('YYYY-MM-DD'));
    }
    dates.push(date2.format('YYYY-MM-DD'));
    return dates;
  },
  getMonthEndDateBeforeNMonths: function getMonthEndDateBeforeNMonths(inputDate, numberMonths) {
    return (0, _moment2.default)(inputDate).subtract(numberMonths, 'M').endOf('month').format('YYYY-MM-DD');
  },
  getTimeInHoursAndMinutes: function getTimeInHoursAndMinutes(timeIn24HrFormat) {
    if ((0, _functional_utility.isNilOrEmpty)(timeIn24HrFormat) || !/^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(timeIn24HrFormat) && !/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeIn24HrFormat)) {
      return '-';
    }

    return (0, _moment2.default)(timeIn24HrFormat, 'HH:mm').format('HH:mm');
  },
  getTimeInHoursInESTFormat: function getTimeInHoursInESTFormat(inputDateInStringFormat) {
    if ((0, _functional_utility.isNilOrEmpty)(inputDateInStringFormat)) {
      return null;
    }
    return (0, _momentTimezone2.default)(inputDateInStringFormat).tz("America/New_York").format("ha").toUpperCase();
  },
  getTimeInHoursAndMinutesInESTFormat: function getTimeInHoursAndMinutesInESTFormat(inputDateInStringFormat) {
    if ((0, _functional_utility.isNilOrEmpty)(inputDateInStringFormat)) {
      return null;
    }
    return (0, _momentTimezone2.default)(inputDateInStringFormat).tz("America/New_York").format("h:mma").toUpperCase();
  },
  getTimeInHoursAndMinutesInTimeZoneFormat: function getTimeInHoursAndMinutesInTimeZoneFormat(inputDateInStringFormat) {
    var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'America/New_York';
    var is24HrFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if ((0, _functional_utility.isNilOrEmpty)(inputDateInStringFormat)) {
      return null;
    }

    var format = is24HrFormat ? 'HH:mm' : 'h:mma';

    if (timeZone === 'UTC') {
      return (0, _momentTimezone2.default)(inputDateInStringFormat).utc().format(format).toUpperCase();
    }

    return (0, _momentTimezone2.default)(inputDateInStringFormat).tz(timeZone).format(format).toUpperCase();
  },
  getTranslatedDate: function getTranslatedDate(intl, effectiveDate, month, day) {
    return intl.formatDate(effectiveDate, { month: month, day: day }).replace(String.fromCharCode(26376, 8206), '‎');
  },
  getTranslatedDateYear: function getTranslatedDateYear(intl, effectiveDate, month, year) {
    return intl.formatDate(effectiveDate, { month: month, year: year }).replace(String.fromCharCode(26376, 8206), '‎');
  },
  getTranslatedHeaderWithDate: function getTranslatedHeaderWithDate(inputEffectiveDate) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pdp-as-of-date-header';
    var defaultMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return getIntlFormattedDate(key, defaultMessage, inputEffectiveDate);
  },
  isValidDate: function isValidDate(inputDate) {
    return (0, _moment2.default)(inputDate, edpiDateFormat, true).isValid();
  },
  validateDateMMYYYY: function validateDateMMYYYY(inputDate) {
    var regExMMYYYY = /^\d{2}(\/|\.)\d{4}$/;
    if (!inputDate.trim().match(regExMMYYYY)) {
      return false;
    }
    return (0, _moment2.default)(inputDate, 'MM/YYYY').isValid();
  },
  getFullYear: function getFullYear(date) {
    return new Date(date).getUTCFullYear();
  },
  addYearMapsToDateRangeArray: function addYearMapsToDateRangeArray(dateRangeArray, yearMapArray, maxDate, minDate) {
    var index = void 0;
    for (index = 0; index < yearMapArray.length; index++) {
      if ((0, _moment2.default)(maxDate).diff((0, _moment2.default)(minDate), 'year') >= yearMapArray[index].years) {
        dateRangeArray.push({
          value: yearMapArray[index].value,
          displayValue: 'Last ' + yearMapArray[index].years + ' year' + (yearMapArray[index].years > 1 ? 's' : ''),
          translationKey: 'dropdown-last-' + yearMapArray[index].years + '-year' + (yearMapArray[index].years > 1 ? 's' : '')
        });
      }
    };
  },
  calculateFromDateByDateOptionList: function calculateFromDateByDateOptionList(dateOption, defaultFromDate, defaultToDate) {

    var fromDate = void 0;

    if (dateOption === 0) {
      fromDate = (0, _moment2.default)(defaultFromDate);
    } else {
      fromDate = _moment2.default.utc(defaultToDate).subtract(dateOption, 'months');
    }
    fromDate = (0, _moment2.default)(DateFormatter.getDateInSpecificFormat(fromDate, "YYYY-MM-DD"));

    return fromDate;
  },
  getCalendarYears: function getCalendarYears(inceptionDate) {
    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

    var inceptionYear = (0, _moment2.default)(inceptionDate).year();
    var currentYear = (0, _moment2.default)(currentDate).year();
    return currentYear - inceptionYear - 1 < 0 ? 0 : currentYear - inceptionYear - 1;
  },
  getYearsSinceInception: function getYearsSinceInception(inceptionDate) {
    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

    return (0, _moment2.default)(currentDate).diff(inceptionDate, 'years');
  },
  getCalendarYearsSinceInception: function getCalendarYearsSinceInception(inceptionDate) {
    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

    var isIncDateFirstDayOfYear = (0, _moment2.default)(inceptionDate).dayOfYear() === 1;
    var isCurDateLastDayOfYear = (0, _moment2.default)(currentDate).month() === 11 && (0, _moment2.default)(currentDate).date() === 31;

    if ((0, _moment2.default)(currentDate).year() === (0, _moment2.default)(inceptionDate).year() && isIncDateFirstDayOfYear && isCurDateLastDayOfYear) {
      return 1;
    }

    if ((0, _moment2.default)(currentDate).diff(inceptionDate, "years", true) < 1) {
      return 0;
    }

    var diff = 0;
    if (isIncDateFirstDayOfYear) {
      diff += 1;
    }
    if (isCurDateLastDayOfYear) {
      diff += 1;
    }

    return getCalendarYears(inceptionDate, currentDate) + diff;
  }
};

exports.default = DateFormatter;
var getFormattedDateAvailebleHeader = DateFormatter.getFormattedDateAvailebleHeader,
    getDateInSlashFormat = DateFormatter.getDateInSlashFormat,
    getDateInDotFormat = DateFormatter.getDateInDotFormat,
    getDateInSlashFormatOrNA = DateFormatter.getDateInSlashFormatOrNA,
    getDateInDDMMYYYSlashFormat = DateFormatter.getDateInDDMMYYYSlashFormat,
    getDateInYYYYMMDDSlashFormat = DateFormatter.getDateInYYYYMMDDSlashFormat,
    convertTimeTo12HrFrom24HrFormat = DateFormatter.convertTimeTo12HrFrom24HrFormat,
    getTimeInHoursAndMinutesInESTFormat = DateFormatter.getTimeInHoursAndMinutesInESTFormat,
    getTimeInHoursInESTFormat = DateFormatter.getTimeInHoursInESTFormat,
    getDateInESTFormat = DateFormatter.getDateInESTFormat,
    getTimeInHoursAndMinutesInTimeZoneFormat = DateFormatter.getTimeInHoursAndMinutesInTimeZoneFormat,
    getFirstDateForLastNMonths = DateFormatter.getFirstDateForLastNMonths,
    getDateInSpecificFormat = DateFormatter.getDateInSpecificFormat,
    getDatesFromGivenDateForGivenTickInterval = DateFormatter.getDatesFromGivenDateForGivenTickInterval,
    getFutureDatesFromGivenDateForGivenTickInterval = DateFormatter.getFutureDatesFromGivenDateForGivenTickInterval,
    getDateInMonthYearFormat = DateFormatter.getDateInMonthYearFormat,
    getDateInMonthDayYearFormat = DateFormatter.getDateInMonthDayYearFormat,
    getMonthEndsBetweenDatesForBP1 = DateFormatter.getMonthEndsBetweenDatesForBP1,
    getDateBeforeNMonths = DateFormatter.getDateBeforeNMonths,
    getMonthEndDateBeforeNMonths = DateFormatter.getMonthEndDateBeforeNMonths,
    getDateAfterNMonths = DateFormatter.getDateAfterNMonths,
    getBusinessDatesFromGivenDateArray = DateFormatter.getBusinessDatesFromGivenDateArray,
    isValidDate = DateFormatter.isValidDate,
    formatDateForLocale = DateFormatter.formatDateForLocale,
    validateDateMMYYYY = DateFormatter.validateDateMMYYYY,
    dateRangeIsGreaterThanAYear = DateFormatter.dateRangeIsGreaterThanAYear,
    fromDateIsBeforeToDate = DateFormatter.fromDateIsBeforeToDate,
    fromDateIsAfterToDate = DateFormatter.fromDateIsAfterToDate,
    fromDateIsSameOrAfterToDate = DateFormatter.fromDateIsSameOrAfterToDate,
    convertDateToLastDayOfMonth = DateFormatter.convertDateToLastDayOfMonth,
    getIntlFormattedDate = DateFormatter.getIntlFormattedDate,
    formattedDateValObj = DateFormatter.formattedDateValObj,
    getTimeInHoursAndMinutes = DateFormatter.getTimeInHoursAndMinutes,
    getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick = DateFormatter.getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick,
    getDateInMonthYearFormatInMMYYYY = DateFormatter.getDateInMonthYearFormatInMMYYYY,
    getDateInMonthYearWithFormat = DateFormatter.getDateInMonthYearWithFormat,
    getDateInMonthYearFormatNoOffset = DateFormatter.getDateInMonthYearFormatNoOffset,
    getTranslatedHeaderWithDate = DateFormatter.getTranslatedHeaderWithDate,
    getEffectiveDateHeader = DateFormatter.getEffectiveDateHeader,
    getLocalFormattedDateForInjectIntl = DateFormatter.getLocalFormattedDateForInjectIntl,
    getTranslatedDate = DateFormatter.getTranslatedDate,
    getTranslatedDateYear = DateFormatter.getTranslatedDateYear,
    getLocalFormattedDate = DateFormatter.getLocalFormattedDate,
    generateLocale = DateFormatter.generateLocale,
    getFullYear = DateFormatter.getFullYear,
    addYearMapsToDateRangeArray = DateFormatter.addYearMapsToDateRangeArray,
    calculateFromDateByDateOptionList = DateFormatter.calculateFromDateByDateOptionList,
    getCalendarYears = DateFormatter.getCalendarYears,
    getYearsSinceInception = DateFormatter.getYearsSinceInception,
    getCalendarYearsSinceInception = DateFormatter.getCalendarYearsSinceInception;
exports.getFormattedDateAvailebleHeader = getFormattedDateAvailebleHeader;
exports.getDateInSlashFormat = getDateInSlashFormat;
exports.getDateInDotFormat = getDateInDotFormat;
exports.getDateInSlashFormatOrNA = getDateInSlashFormatOrNA;
exports.getDateInDDMMYYYSlashFormat = getDateInDDMMYYYSlashFormat;
exports.getDateInYYYYMMDDSlashFormat = getDateInYYYYMMDDSlashFormat;
exports.convertTimeTo12HrFrom24HrFormat = convertTimeTo12HrFrom24HrFormat;
exports.getTimeInHoursAndMinutesInESTFormat = getTimeInHoursAndMinutesInESTFormat;
exports.getTimeInHoursInESTFormat = getTimeInHoursInESTFormat;
exports.getDateInESTFormat = getDateInESTFormat;
exports.getTimeInHoursAndMinutesInTimeZoneFormat = getTimeInHoursAndMinutesInTimeZoneFormat;
exports.getFirstDateForLastNMonths = getFirstDateForLastNMonths;
exports.getDateInSpecificFormat = getDateInSpecificFormat;
exports.getDatesFromGivenDateForGivenTickInterval = getDatesFromGivenDateForGivenTickInterval;
exports.getFutureDatesFromGivenDateForGivenTickInterval = getFutureDatesFromGivenDateForGivenTickInterval;
exports.getDateInMonthYearFormat = getDateInMonthYearFormat;
exports.getDateInMonthDayYearFormat = getDateInMonthDayYearFormat;
exports.getMonthEndsBetweenDatesForBP1 = getMonthEndsBetweenDatesForBP1;
exports.getDateBeforeNMonths = getDateBeforeNMonths;
exports.getMonthEndDateBeforeNMonths = getMonthEndDateBeforeNMonths;
exports.getDateAfterNMonths = getDateAfterNMonths;
exports.getBusinessDatesFromGivenDateArray = getBusinessDatesFromGivenDateArray;
exports.isValidDate = isValidDate;
exports.formatDateForLocale = formatDateForLocale;
exports.validateDateMMYYYY = validateDateMMYYYY;
exports.dateRangeIsGreaterThanAYear = dateRangeIsGreaterThanAYear;
exports.fromDateIsBeforeToDate = fromDateIsBeforeToDate;
exports.fromDateIsAfterToDate = fromDateIsAfterToDate;
exports.fromDateIsSameOrAfterToDate = fromDateIsSameOrAfterToDate;
exports.convertDateToLastDayOfMonth = convertDateToLastDayOfMonth;
exports.getIntlFormattedDate = getIntlFormattedDate;
exports.formattedDateValObj = formattedDateValObj;
exports.getTimeInHoursAndMinutes = getTimeInHoursAndMinutes;
exports.getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick = getDatesFromGivenDateRangeForGivenTickIntervalWithStartDateAsFirstTick;
exports.getDateInMonthYearFormatInMMYYYY = getDateInMonthYearFormatInMMYYYY;
exports.getDateInMonthYearWithFormat = getDateInMonthYearWithFormat;
exports.getDateInMonthYearFormatNoOffset = getDateInMonthYearFormatNoOffset;
exports.getTranslatedHeaderWithDate = getTranslatedHeaderWithDate;
exports.getEffectiveDateHeader = getEffectiveDateHeader;
exports.getLocalFormattedDateForInjectIntl = getLocalFormattedDateForInjectIntl;
exports.getTranslatedDate = getTranslatedDate;
exports.getTranslatedDateYear = getTranslatedDateYear;
exports.getLocalFormattedDate = getLocalFormattedDate;
exports.generateLocale = generateLocale;
exports.getFullYear = getFullYear;
exports.addYearMapsToDateRangeArray = addYearMapsToDateRangeArray;
exports.calculateFromDateByDateOptionList = calculateFromDateByDateOptionList;
exports.getCalendarYears = getCalendarYears;
exports.getYearsSinceInception = getYearsSinceInception;
exports.getCalendarYearsSinceInception = getCalendarYearsSinceInception;